// assets/js/modules/projectsView.js
//
// Gère le toggle grid/list dans le template projects.php unifié.
// - Lit la préférence depuis localStorage
// - Met à jour data-view sur .project-listing pour masquer le conteneur inactif (CSS)
// - Gère le lifecycle de WaveList (list) et ProjectItemCursor (grid)
//
// Ne pas utiliser dans projects-gridpage.php / projects-listpage.php
// (ces templates conservent leurs propres initialisations dans main.js)

import * as WaveList         from './wave-list.js';
import * as ProjectItemCursor from './projectItemCursor.js';

const STORAGE_KEY   = 'projects-view';
const DESKTOP_QUERY = '(min-width: 1180px)';

let currentView = 'grid';
let ac          = null;

export function init() {
    const listing = document.querySelector('.project-listing[data-view]');
    const buttons = document.querySelectorAll('[data-view-btn]');
    if (!listing || !buttons.length) return;

    // Mobile: view-switch is hidden, always force grid regardless of a
    // preference saved from a previous desktop visit.
    const isDesktop = window.matchMedia(DESKTOP_QUERY).matches;
    const saved = isDesktop ? (localStorage.getItem(STORAGE_KEY) || 'grid') : 'grid';
    _applyView(saved, listing, buttons);

    ac = new AbortController();
    buttons.forEach(btn => {
        btn.addEventListener('click', () => {
            const v = btn.dataset.viewBtn;
            if (v !== currentView) {
                _applyView(v, listing, buttons);
                localStorage.setItem(STORAGE_KEY, v);
            }
        }, { signal: ac.signal });
    });
}

function _applyView(view, listing, buttons) {
    // Détruire le module actif avant de switcher
    if (currentView === 'grid') ProjectItemCursor.destroy();
    else                        WaveList.destroy();

    currentView       = view;
    listing.dataset.view = view;

    // Mettre à jour l'état actif des boutons
    buttons.forEach(btn =>
        btn.classList.toggle('is-active', btn.dataset.viewBtn === view)
    );

    // Initialiser le module correspondant à la nouvelle vue
    if (view === 'grid') ProjectItemCursor.init();
    else                 WaveList.init();
}

export function destroy() {
    ac?.abort();
    ac = null;
    if (currentView === 'grid') ProjectItemCursor.destroy();
    else                        WaveList.destroy();
}
